import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AssistanceAudience, AssistanceModule } from '../interfaces/assistance-resource';
import { ApiCollectionResponse } from '../interfaces/responses/api-response';

/** Segment de route de chaque public, côté API. */
const AUDIENCE_SEGMENT: Record<AssistanceAudience, string> = {
  Professor: 'professor',
  Student: 'student',
  Admin: 'admin',
};

/**
 * Lecture de l'aide — la même pour tous les rôles, sans aucune écriture.
 * Le serveur ferme chaque public à qui n'en fait pas partie.
 */
@Injectable({ providedIn: 'root' })
export class AssistanceService {
  private readonly base = `${environment.BASE_URL}/assistance`;

  constructor(private http: HttpClient) {}

  /** Modules non vides d'un public, chacun avec sa série. */
  getModules(audience: AssistanceAudience): Observable<ApiCollectionResponse<AssistanceModule>> {
    return this.http.get<ApiCollectionResponse<AssistanceModule>>(
      `${this.base}/${AUDIENCE_SEGMENT[audience]}/modules`,
    );
  }

  download(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.base}/${id}/download`, {
      observe: 'response',
      responseType: 'blob',
    });
  }
}
